import InterWebviewBridge, { interWbNavigate, WbEnvironments } from '@interco/inter-webview-bridge'

export class BaseBridge {
  private static readonly interWebView = InterWebviewBridge.getInstance()

  static isBrowser(): boolean {
    return this.interWebView.getEnvironment() === WbEnvironments.BROWSER
  }

  private static handleError(error: unknown, errorCodeRef: string): void {
    console.error(error, errorCodeRef)
  }

  static async openDeepLink(deepLink: string) {
    if (!BaseBridge.isBrowser()) {
      try {
        await interWbNavigate.openDeepLink(deepLink)
      } catch (error) {
        this.handleError(error, 'BaseBridge.openDeepLink')
      }
    }
  }
}
